import * as React from 'react';
import { useTheme } from '@emotion/react';

export const BrowserInspection: React.FC = () => {
  const theme = useTheme();
  const colors = theme.featureGraph;
  return (
    <g transform="translate(20 300)">
      <rect
        width="315"
        height="255"
        rx="12"
        fill={theme.surface.background}
        stroke={colors.runtime.accent}
        strokeWidth="2"
      />
      <path d="M0 32 H315" stroke={colors.runtime.border} />
      {[16, 28, 40].map((x) => (
        <circle key={x} cx={x} cy="16" r="3" fill={colors.runtime.muted} />
      ))}
      <rect x="64" y="9" width="224" height="14" rx="4" fill={theme.card.background} />
      <text x="176" y="19" textAnchor="middle" fill={theme.text.paragraph} fontSize="8">
        Site inspection · Web app
      </text>
      <text x="18" y="56" fill={colors.runtime.accent} fontSize="9" letterSpacing="1.5">
        FIELD OPERATIONS
      </text>
      <text x="18" y="83" fill={theme.text.heading} fontSize="21" fontWeight="600">
        Site inspection
      </text>
      <text x="18" y="103" fill={theme.text.paragraph} fontSize="10">
        Pump station · Unit 04
      </text>
      <rect x="18" y="119" width="128" height="75" rx="8" fill={theme.card.background} />
      <path
        d="M30 180 V145 H54 V158 H77 V136 H101 V169 H132 V180 Z"
        fill={colors.runtime.background}
        stroke={colors.runtime.muted}
        strokeWidth="1.5"
      />
      <circle cx="124" cy="135" r="5" fill={colors.runtime.muted} />
      <text x="160" y="145" fill={theme.text.heading} fontSize="10">
        Equipment checked
      </text>
      <text x="293" y="145" textAnchor="end" fill={colors.feature.accent} fontSize="14">
        ✓
      </text>
      <text x="160" y="176" fill={theme.text.heading} fontSize="10">
        Photo captured
      </text>
      <text x="293" y="176" textAnchor="end" fill={colors.feature.accent} fontSize="14">
        ✓
      </text>
      <rect
        x="18"
        y="210"
        width="279"
        height="28"
        rx="7"
        fill={colors.runtime.background}
        stroke={colors.runtime.border}
      />
      <circle cx="32" cy="224" r="3" fill={colors.feature.accent} />
      <text x="45" y="228" fill={theme.text.heading} fontSize="10">
        Inspection synchronized
      </text>
    </g>
  );
};
